import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import formatCurrency from '~shared/utils/currencyUtils';

import './styles.scss';

const Payout = ({ payout }) => {
    const [ t ] = useTranslation();

    return (
        <>
            <div className="fullslip__payout-text">
                {t('betslip.return')}:
            </div>
            <div className="fullslip__payout-price" data-test-id="betslip;returns">
                {formatCurrency(payout, undefined, undefined, false)}
            </div>
        </>
    );
};

Payout.propTypes = {
    payout: PropTypes.oneOfType([
        PropTypes.number,
        PropTypes.string,
    ]).isRequired,
};

export default Payout;
